import apiService from "./apiService";
import AppConstants from "../appConstants";

class LogicalNumberService {
    getAllLogicalNumber(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LOGICAL_NUMBER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getLogicalNumberDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_LOGICAL_NUMBER_DETAIL}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerLogicalNumber(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_LOGICAL_NUMBER, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteLogicalNumber(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_LOGICAL_NUMBER}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_LOGICAL_NUMBER_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    sync(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LOGICAL_NUMBER_SYNC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================
    
}

export default new LogicalNumberService();
